export default {
  modalMessage: 'If you quit now, you be unable to sign into My Client Space.',
};
